import { injectable } from 'inversify';

import axios from 'axios';

import IocContainer from '../container/IocContainer';
import SERVICES     from '../services/services';

import Auth from '../interfaces/Auth';
import Payment, { ShopProduct, CouponCheck, PaymentResult } from '../interfaces/Payment';

@injectable()
export default class paymentsProvider implements Payment {

  http;
  path = '/courses/';
  auth = IocContainer.get<Auth>(SERVICES.AUTH);

  constructor () {
    this.http = axios.create({
      baseURL: process.env.API_URL,
      headers: {
        Accept: 'application/json',
      },
    });
  }

  private headers() {
    return {
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.auth.token(),
    };
  }

  // Rejects on non-2xx; callers read error.response.data.message.
  public async getProducts(): Promise<ShopProduct[]> {
    const response = await this.http.get('/products', { headers: this.headers() });
    return response.data.success ? response.data.products : [];
  }

  public async checkCoupon(productId: number, code: string): Promise<CouponCheck> {
    const response = await this.http.post('/coupons/check', { product_id: productId, code }, { headers: this.headers() });
    return response.data;
  }

  public async pay(productId: number, token: string, coupon?: string): Promise<PaymentResult> {
    const body: any = { product_id: productId, token };
    if (coupon) {
      body.coupon = coupon;
    }
    const response = await this.http.post('/payments', body, { headers: this.headers() });
    return response.data;
  }
}
